import { render, staticRenderFns } from "./reclass-bind-dialog.vue?vue&type=template&id=04b0bae6&"
import script from "./reclass-bind-dialog.vue?vue&type=script&lang=js&"
export * from "./reclass-bind-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports